import Base from "./Base";
class Record extends Base {

    static getToken(body) {
        return this.sendRequest("/record/get-token", "POST", {}, body);
    }

    static saveHiddenFields(body) {
        return this.sendRequest("/record/save-hidden-fields", "POST", {}, body);
    }
    
}

export default Record;
// TL.ApiClient.Invite = new Invite();
